module.exports = __webpack_public_path__ + "media/images/flags/1x1/png-81eb2774b550fcd29bf181dec7792f52.svg";